import clsx from "clsx";
import { Badge } from "./Badge";
import styles from "./RoleBadge.module.css";

export type RoleBadgeVariant = "spectator" | "expert";

const LABELS: Record<RoleBadgeVariant, string> = {
  spectator: "Spectateur",
  expert: "Expert",
};

export interface RoleBadgeProps {
  variant: RoleBadgeVariant;
  className?: string;
}

/** Small pill showing a meeting role (spectator / expert), shared across the
 *  topbar, the settings box and the meeting list. */
export const RoleBadge = ({ variant, className }: RoleBadgeProps) => (
  <Badge className={clsx(styles[variant], className)}>
    {LABELS[variant]}
  </Badge>
);

export default RoleBadge;
